import { IOpportunity } from '../../store/models/opportunity.model';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { IUserSessionData, UserType } from 'app/store/models/user.model';
import {
  EFilterType,
  ETableColumnType,
  ITableColumn,
  ITableDataSource,
  ITableFilter,
  ITableFIlterGroup
} from 'app/store/models/table.model';
import { IMeetingItem } from 'app/store/models/meeting.model';
import { Button, ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { Router } from '@angular/router';
import { LeftMenuService } from 'app/store/services/left-menu.service';
import { SessionService } from 'app/store/services/session.service';
import { ContactsService } from '../../store/services/contacts.service';
import { ApiDataSource } from 'app/datasources/api.datasrouce';
import { takeUntil } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { DialogData } from 'app/store/models/dialog.model';
import { InfoTipsComponent } from 'app/dialogs/info-tips/info-tips.component';
import { Store } from '@ngrx/store';
import { IReducers } from 'app/store/reducers';
import { openDialog, openSnackbar } from 'app/store/actions/page.action';
import { environment } from '../../../environments/environment';
import { RContentComponent } from 'app/dialogs/quick-response/r-content.component';
import { updateLeftMenuCount } from 'app/store/actions/meeting.action';
import { ButtonSelectComponent } from '../../shared/ui/button-select/button-select.component';
import { EInfoSelectItemType } from '../../store/models/select.model';
import { TimezonePipe } from '../../shared/ui/pipes/timezone.pipe';
import { UtilitiesService } from '../../store/services/utilities.servive';
import { SentToCampignDialogComponent } from '../../dialogs/sent-to-campign-dialog/sent-to-campign-dialog.component';
import * as moment from 'moment';
import { EForwardType, ForwardDialogComponent } from '../../dialogs/forward-dialog/forward-dialog.component';
import { DialogComponent } from '../../shared/ui/dialog/dialog.component';

enum EMeetingStatus {
  ALL = 'all',
  WON = 'won',
  LOST = 'lost',
  ACTIVE = 'active',
}

@Component({
  selector: 'app-opportunities-listing',
  templateUrl: './opportunities-listing.component.html',
  styleUrls: ['./opportunities-listing.component.scss'],
})
export class OpportunitiesListingComponent implements OnInit, OnDestroy {
  tableDataSourceParams = {
    page: 1,
    pageSize: 10,
    sortAttr: 'action_data1',
    sortDir: 'desc',
    state: '',
    filters: {},
  };
  tableFilterGroups: ITableFIlterGroup[] = [
      {
        filters: [
          {
            type: EFilterType.SEARCH,
            label: 'Search',
            items: [
              {
                id: 'search',
                label: 'Search...',
              },
            ],
          },
        ]
      }
  ];
  tableColumns: ITableColumn<IOpportunity>[];
  dataSource: ApiDataSource<any>;
  exportButtonProperties: Button = {
    onClick: () => {},
    size: ButtonSize.SMALL,
    text: 'Export',
    color: ButtonColor.ORANGE,
  };
  tableReady: boolean;
  showExportButton: boolean;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private filterState: EMeetingStatus = EMeetingStatus.ALL;
  tableFilters: ITableFilter[] = [
    {
      type: EFilterType.SELECT,
      id: 'meeting',
      label: 'View',
      items: [
        {
          id: 'meeting',
          label: 'Active',
          value: EMeetingStatus.ACTIVE,
        },
        {
          id: 'meeting',
          label: 'Won',
          value: EMeetingStatus.WON,
        },
        {
          id: 'meeting',
          label: 'Lost',
          value: EMeetingStatus.LOST,
        },
        {
          id: 'meeting',
          label: 'All',
          value: EMeetingStatus.ALL,
        },
      ],
      onFilterChange: value => {
        this.filterState = value;
        this.dataSource = new ApiDataSource<IMeetingItem>(
          this.http,
          environment.apiUrl + '/v1/messages/opportunities?state=' + value,
        );
        this.tableColumns = this.getTableColumns();
      },
    },
  ];
  private sessionData: IUserSessionData;
  private popupShown: boolean;

  constructor(
    private http: HttpClient,
    private router: Router,
    private leftMenu: LeftMenuService,
    private sessionService: SessionService,
    private contactsService: ContactsService,
    private store: Store<IReducers>,
    private readonly utilitiesService: UtilitiesService,
  ) {
    this.dataSource = new ApiDataSource<IMeetingItem>(
      this.http,
      environment.apiUrl +
      '/v1/messages/opportunities?state=' +
      this.filterState,
    );
    this.exportButtonProperties.onClick = () =>
      this.contactsService.getExport('opportunities').subscribe((response: Blob) => {
        const dataType = response.type;
        const binaryData = [];
        binaryData.push(response);
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(
          new Blob(binaryData, { type: dataType }),
        );

        downloadLink.setAttribute('download', 'opportunities.csv');
        document.body.appendChild(downloadLink);
        downloadLink.click();
      });
    this.leftMenu.expand('inbox');
  }

  rowClass = () => ['route_message'];

  getTableColumns(): ITableColumn<IOpportunity>[] {
    const sessionData = this.sessionData;
    const cols: ITableColumn<IOpportunity>[] = [];
    if (
      sessionData.user_type !== UserType.MANAGER &&
      sessionData.user_type !== UserType.PARTNER
    ) {
      cols.push({
        id: 'response',
        title: 'Reply',
        type: ETableColumnType.COMPONENT,
        leftAdjusted: true,
        disabled: sessionData.user_type !== UserType.SINGLE_USER,
        componentProperties: {
          component: ButtonSelectComponent,
          mapData: {
            attachToBody: {
              instance: 'static',
              target: true,
            },
            buttonProperties: {
              instance: 'static',
              target: {
                text: 'Reply',
                size: ButtonSize.SMALL,
                color: ButtonColor.ORANGE,
              },
            },
            selection: {
              instance: 'function',
              target: rowItem => {
                return selectItem => {
                  this.openItemDialog(rowItem, selectItem);
                };
              },
            },
            items: {
              instance: 'function',
              target: (item: IOpportunity) => {
                const items: any[] = [
                  {
                    label: 'Opportunities',
                    type: EInfoSelectItemType.TYPE_LINK,
                    // value: `/user_contacts/${item.contact_id}/find_template`,
                    dialogContent: this.getDialogData('opportunities'),
                    children: [
                      {
                        label: 'Meetings',
                        tag: 'meeting',
                        type: EInfoSelectItemType.TYPE_LINK,
                        // value: `/user_contacts/${item.contact_id}/find_template`,
                        dialogContent: this.getDialogData('meeting'),
                      },
                      {
                        label: 'Order/Quote',
                        type: EInfoSelectItemType.TYPE_LINK,
                        tag: 'order',
                        // value: `/user_contacts/${item.contact_id}/find_template`,
                        dialogContent: this.getDialogData('order'),
                      },
                    ],
                  },
                  {
                    label: 'Cycle',
                    type: EInfoSelectItemType.TYPE_LINK,
                    tag: 'cycle',
                    // value: `/user_contacts/${item.contact_id}/find_template`,
                    dialogContent: this.getDialogData('cycle'),
                  },
                  {
                    label: 'Follow up',
                    type: EInfoSelectItemType.TYPE_LINK,
                    tag: 'followup',
                    // value: `/user_contacts/${item.contact_id}/find_template`,
                    dialogContent: this.getDialogData('follow_up'),
                  },
                  {
                    label: 'Inactive',
                    type: EInfoSelectItemType.TYPE_LINK,
                    tag: 'inactive',
                    // value: `/user_contacts/${item.contact_id}/find_template`,
                    dialogContent: this.getDialogData('inactive'),
                  },
                  {
                    label: 'Remove',
                    type: EInfoSelectItemType.TYPE_LINK,
                    tag: 'remove',
                    // value: `/user_contacts/${item.contact_id}/find_template`,
                    dialogContent: this.getDialogData('remove'),
                  },
                  {
                    label: 'Conversation',
                    type: EInfoSelectItemType.TYPE_LINK,
                    tag: 'conversation',
                    // value: `/user_contacts/${item.contact_id}/find_template`,
                    dialogContent: this.getDialogData('conversation'),
                  },
                  {
                    label: 'Forward',
                    type: EInfoSelectItemType.TYPE_LINK,
                    tag: 'forward',
                    // value: `/user_contacts/${item.contact_id}/find_template`,
                    dialogContent: this.getDialogData('forward'),
                  },
                  {
                    label: 'Send Email',
                    tag: 'send-email',
                    type: EInfoSelectItemType.TYPE_NORMAL,
                    value: 'send_email',
                    dialogContent: this.getDialogData('send_email'),
                  },
                ];

                if (
                  this.sessionData.user_type === UserType.SINGLE_USER
                ) {
                  items.push({
                    label: 'Send to campaign',
                    type: EInfoSelectItemType.TYPE_NORMAL,
                    dialogContent: this.getDialogData('back_to_campaign'),
                    onClick: () => this.store.dispatch(openDialog({
                      dialogData: {
                        content: SentToCampignDialogComponent,
                        dialogMinWidth: '600px',
                        canClose: true,
                        title: `Sent ${item.contact_firstname || ''} ${item.contact_lastname || ''} to campaign`,
                        buttons: [{
                          text: 'Send',
                          color: ButtonColor.GREEN,
                          size: ButtonSize.NORMAL,
                          onClick: (dialog) => {
                            if(!dialog.component.componentReady) {
                              return false;
                            }
                            if (!dialog.dialogForm.valid) {
                              dialog.dialogForm.markAllAsTouched();
                              return;
                            }

                            const campaignId = dialog.dialogForm.value.campaign_id;
                            const groupId = dialog.dialogForm.value.group_id;
                            const startDate = moment(dialog.dialogForm.value.start_date).format('YYYY-MM-DD');

                            this.contactsService.sendContactToCampaign(
                              item.contact_id,
                              campaignId,
                              groupId,
                              startDate,
                            ).subscribe(
                              () => {
                                this.store.dispatch(openSnackbar({
                                  snackbarData: {
                                    data: {
                                      message: 'Contact successfully send to campaign!',
                                      type: 'success',
                                    },
                                  },
                                }));
                                dialog.closeDialog();
                                this.dataSource.refresh();
                              },
                              err => this.store.dispatch(openSnackbar({
                                snackbarData: {
                                  data: {
                                    message: err.error,
                                    type: 'error',
                                  },
                                },
                              })),
                            );
                          },
                        }],
                      },
                    })),
                  });
                }

                return items;
              },
            },
          },
        },
      });
    }
    let columns: ITableColumn<IOpportunity>[] = [
      ...cols,
      {
        id: 'current_status',
        title: 'Current Status',
        class: 'current-status-col',
        sortable: true,
        asHtml: true,
        leftAdjusted: true,
        renderer: (row: IOpportunity) => {
          if (row.current_status) {
            return `<span class='current-status-opp'>${row.current_status}</span>`;
          }

          if (row.campaign_name) {
            return `<span class='current-status-opp'>Current Campaign Assigned: ${row.campaign_name}</span>`;
          }

          return '';
        },
        route: row => this.onColumnClick(row),
      },
      {
        id: 'status_date',
        title: 'Current Status Date',
        sortable: true,
        route: row => this.onColumnClick(row),
        isDateColumn: true,
        leftAdjusted: true,
      },
      {
        id: 'est_value',
        title: 'Estimated Revenue',
        sortable: false,
        route: row => this.onColumnClick(row),
        leftAdjusted: true,
      },
      {
        id: 'actual_value',
        title: 'Actual Revenue',
        sortable: false,
        route: row => this.onColumnClick(row),
        leftAdjusted: true,
      },
      {
        id: 'contact_firstname',
        title: 'Contact',
        sortable: true,
        renderer: row => {
          return `${row.contact_firstname ? row.contact_firstname : ''} ${
            row.contact_lastname ? row.contact_lastname : ''
          }`;
        },
        route: row => this.onColumnClick(row),
        leftAdjusted: true,
      },
      {
        id: 'campaign_name',
        title: 'Campaign',
        sortable: true,
        route: row => this.onColumnClick(row),
        leftAdjusted: true,
      },
      {
        id: 'contact_company',
        title: 'Company',
        sortable: true,
        route: row => this.onColumnClick(row),
        leftAdjusted: true,
      },
    ];

    if (this.filterState) {
      const timezonePipe = new TimezonePipe(this.utilitiesService);
      switch (this.filterState) {
        case EMeetingStatus.ALL:
          columns = [
            ...columns,
            {
              id: 'opportunity_date',
              title: 'Opportunity Date',
              sortable: true,
              route: row => this.onColumnClick(row),
              leftAdjusted: true,
              renderer: row => timezonePipe.transform(row.opportunity_date, 'MM/DD/YYYY hh:mm a'),
            },
          ];
          break;
        case EMeetingStatus.ACTIVE:
          columns = [
            {
              id: 'meeting_contact_id',
              title: 'Contact',
              sortable: true,
              renderer: row => {
                return `${row.contact_firstname} ${row.contact_lastname}`;
              },
              route: row => this.onColumnClick(row),
              leftAdjusted: true,
            },
            {
              id: 'product_name',
              title: 'Product',
              sortable: true,
              route: row => this.onColumnClick(row),
              leftAdjusted: true,
            },
            {
              id: 'contact_company',
              title: 'Company',
              sortable: true,
              route: row => this.onColumnClick(row),
              leftAdjusted: true,
            },
            {
              id: 'meeting_date',
              title: 'Meeting Date',
              sortable: true,
              route: row => this.onColumnClick(row),
              leftAdjusted: true,
            },
            {
              id: 'pipeline_step',
              title: 'Pipeline State',
              sortable: true,
              route: row => this.onColumnClick(row),
              leftAdjusted: true,
            },
            {
              id: 'product_status_date',
              title: 'Estimated date',
              sortable: true,
              route: row => this.onColumnClick(row),
              leftAdjusted: true,
            },
            {
              id: 'est_value',
              title: 'Estimated Value',
              sortable: true,
              route: row => this.onColumnClick(row),
              leftAdjusted: true,
            },
          ];

          // columns = [
          //   ...columns,
          //   {
          //     id: 'meeting_date',
          //     title: 'Meeting Date',
          //     sortable: true,
          //     route: (row) => this.onColumnClick(row)
          //   },
          //   {
          //     id: 'pipeline_state',
          //     title: 'Pipeline State',
          //     sortable: true,
          //     route: (row) => this.onColumnClick(row)
          //   }
          // ];
          break;
        case EMeetingStatus.WON:
          columns = [
            {
              id: 'meeting_contact_id',
              title: 'Contact',
              sortable: true,
              renderer: row => {
                return `${row.contact_firstname} ${row.contact_lastname}`;
              },
              route: row => this.onColumnClick(row),
              leftAdjusted: true,
            },
            {
              id: 'product_name',
              title: 'Product',
              sortable: true,
              route: row => this.onColumnClick(row),
              leftAdjusted: true,
            },
            {
              id: 'contact_company',
              title: 'Company',
              sortable: true,
              route: row => this.onColumnClick(row),
              leftAdjusted: true,
            },
            {
              id: 'opportunity_date',
              title: 'Meeting Date',
              sortable: true,
              route: row => this.onColumnClick(row),
              leftAdjusted: true,
            },
            {
              id: 'pipeline_step',
              title: 'Pipeline State',
              sortable: true,
              route: row => this.onColumnClick(row),
              leftAdjusted: true,
            },
            {
              id: 'product_status_date',
              title: 'Status date',
              sortable: true,
              route: row => this.onColumnClick(row),
              leftAdjusted: true,
            },
            {
              id: 'est_value',
              title: 'Estimated Value',
              sortable: true,
              route: row => this.onColumnClick(row),
              leftAdjusted: true,
            },
            {
              id: 'actual_value',
              title: 'Actual Revenue',
              sortable: true,
              route: row => this.onColumnClick(row),
              leftAdjusted: true,
            },
            {
              id: 'renewal_date',
              title: 'Renewal Date',
              sortable: true,
              route: row => this.onColumnClick(row),
              leftAdjusted: true,
            },
          ];

          // columns = [
          //   ...columns,
          //   {
          //     id: 'won_lost_date',
          //     title: 'Won Date',
          //     sortable: true,
          //     route: (row) => this.onColumnClick(row)
          //   },
          //   {
          //     id: 'contract_value',
          //     title: 'Contract Value',
          //     sortable: true,
          //     route: (row) => this.onColumnClick(row)
          //   },
          // ];
          break;
        case EMeetingStatus.LOST:
          columns = [
            {
              id: 'meeting_contact_id',
              title: 'Contact',
              sortable: true,
              renderer: row => {
                return `${row.contact_firstname} ${row.contact_lastname}`;
              },
              route: row => this.onColumnClick(row),
              leftAdjusted: true,
            },
            {
              id: 'product_name',
              title: 'Product',
              sortable: true,
              route: row => this.onColumnClick(row),
              leftAdjusted: true,
            },
            {
              id: 'contact_company',
              title: 'Company',
              sortable: true,
              route: row => this.onColumnClick(row),
              leftAdjusted: true,
            },
            {
              id: 'opportunity_date',
              title: 'Meeting Date',
              sortable: true,
              route: row => this.onColumnClick(row),
              leftAdjusted: true,
            },
            {
              id: 'pipeline_step',
              title: 'Pipeline State',
              sortable: true,
              route: row => this.onColumnClick(row),
              leftAdjusted: true,
            },
            {
              id: 'product_status_date',
              title: 'Status date',
              sortable: true,
              route: row => this.onColumnClick(row),
              leftAdjusted: true,
            },
            {
              id: 'est_value',
              title: 'Estimated Value',
              sortable: true,
              route: row => this.onColumnClick(row),
              leftAdjusted: true,
            },
          ];

          // columns = [
          //   ...columns,
          //   {
          //     id: 'won_lost_date',
          //     title: 'Lost Date',
          //     sortable: true,
          //     route: (row) => this.onColumnClick(row)
          //   },
          //   {
          //     id: 'lost_reason_code',
          //     title: 'Lost Reason Code',
          //     sortable: true,
          //     route: (row) => this.onColumnClick(row)
          //   }
          // ];
          break;
      }
    }

    if (
      sessionData.user_type === UserType.MANAGER ||
      sessionData.user_type === UserType.PARTNER
    ) {
      columns.push({
        id: 'account_firstname',
        title: 'Representative',
        sortable: true,
        renderer: row => {
          if (!row.account_firstname && !row.account_lastname) {
            return row.account_id.toString();
          }
          return `${row.account_firstname} ${row.account_lastname}`;
        },
        route: row => this.onColumnClick(row),
        leftAdjusted: true,
      });
    }

    return columns;
  }

  openDialog(item, data) {
    data.contact_email = item.contact_email;
    this.store.dispatch(
      openDialog({
        dialogData: {
          title: data.label,
          content: RContentComponent,
          componentData: {
            data,
            contact_id: item.contact_id,
            item,
          },
          onClose: () => this.dataSource.refresh(),
          dialogMinWidth: '1000px',
          canClose: true,
          tips: ['cycle', 'followup', 'meeting', 'inactive', 'remove'].indexOf(data.tag) !== -1 ? 'send-update' : null,
          // buttons: [
          //   {
          //       text: 'Ok',
          //       actAsClose: true,
          //       color: ButtonColor.GREEN,
          //       size: ButtonSize.NORMAL,
          //   },
          //     {
          //         text: 'Close',
          //         actAsClose: true,
          //         color: ButtonColor.RED,
          //         size: ButtonSize.NORMAL,
          //         onClick: () => console.log('cska')
          //     }
          // ]
        },
      }),
    );

    console.log('show  dialog', item);
  }

  openSendEmailDialog(item, data) {
    this.store.dispatch(
      openDialog({
        dialogData: {
          title: data.label,
          content: RContentComponent,
          componentData: {
            data,
            contact_id: item.contact_id,
          },
          dialogMinWidth: '1000px',
          canClose: true,
          buttons: [
            {
              text: 'Ok',
              actAsClose: true,
              color: ButtonColor.GREEN,
              size: ButtonSize.NORMAL,
            },
            {
              text: 'Close',
              actAsClose: true,
              color: ButtonColor.RED,
              size: ButtonSize.NORMAL,
              onClick: () => console.log('cska'),
            },
          ],
        },
      }),
    );

    console.log('show send email dialog', item);
  }

  openAddToCampaignDialog(item, data) {
    this.store.dispatch(
      openDialog({
        dialogData: {
          title: data.label,
          content: RContentComponent,
          componentData: {
            data,
          },
          dialogMinWidth: '1000px',
          canClose: true,
          buttons: [
            {
              text: 'Ok',
              actAsClose: true,
              color: ButtonColor.GREEN,
              size: ButtonSize.NORMAL,
            },
            {
              text: 'Close',
              actAsClose: true,
              color: ButtonColor.RED,
              size: ButtonSize.NORMAL,
              onClick: () => console.log('cska'),
            },
          ],
        },
      }),
    );

    console.log('show campaign dialog', item);
  }

  openItemDialog(itemRow, selectedItem) {
    switch (selectedItem.tag) {
      case 'got-it':
        this.contactsService
          .quickResponse({ contact_id: itemRow.contact_id }, 'okgotit')
          .subscribe(response => {
            this.store.dispatch(updateLeftMenuCount({ data: {} }));
          });
        // v1/messages/okgotit
        break;
      // case 'send-mail':
      //   this.openSendEmailDialog(itemRow, selectedItem);
      //   break;
      case 'send-to-campaign':
        this.openAddToCampaignDialog(itemRow, selectedItem);
        break;
      case 'forward':
        this.store.dispatch(openDialog({
          dialogData: {
            title: `Forward ${itemRow.message_id}`,
            canClose: true,
            content: ForwardDialogComponent,
            componentData: {
              messageId: itemRow.message_id,
            },
            buttons: [
              {
                text: 'Forward',
                color: ButtonColor.GREEN,
                size: ButtonSize.NORMAL,
                onClick: (dialog: DialogComponent) => {
                  if (!dialog.dialogForm.valid) {
                    dialog.dialogForm.markAllAsTouched();
                    return;
                  }

                  if (dialog.dialogForm.get('forward_type').value === EForwardType.ACCOUNT) {
                    this.contactsService.forwardResponse(itemRow.message_id, dialog.dialogForm.get('contact_details').value).subscribe(() => {
                        this.store.dispatch(
                          openSnackbar({
                            snackbarData: {
                              data: {
                                message: 'Message forwarded to your email address',
                                type: 'success',
                                button: {
                                  text: 'dismiss',
                                },
                              },
                              verticalPosition: 'bottom',
                            },
                          }),
                        );
                        dialog.closeDialog();
                      },
                      err => {
                        this.store.dispatch(openSnackbar({
                          snackbarData: {
                            data: {
                              message: err.error,
                              type: 'error',
                            },
                          },
                        }));
                        dialog.closeDialog();
                      },
                    );
                    return;
                  }

                  this.contactsService.forwardResponseToRecipients(itemRow.message_id, dialog.dialogForm.get('recipients').value, dialog.dialogForm.get('contact_details').value)
                    .subscribe(() => {
                        this.store.dispatch(
                          openSnackbar({
                            snackbarData: {
                              data: {
                                message: `Message forwarded to the following recipients: ${dialog.dialogForm.get('recipients').value}`,
                                type: 'success',
                              },
                            },
                          }),
                        );
                        dialog.closeDialog();
                      },
                      err => {
                        this.store.dispatch(openSnackbar({
                          snackbarData: {
                            data: {
                              message: err.error,
                              type: 'error',
                            },
                          },
                        }));
                        dialog.closeDialog();
                      });
                },
              },
            ],
          },
        }));
        break;
      default:
        this.openDialog(itemRow, selectedItem);
        break;
    }
  }

  getDialogData(type): DialogData {
    return {
      content: InfoTipsComponent,
      title: 'Tips',
      canClose: true,
      dialogMinWidth: '700px',
      componentData: {
        type,
      },
    };
  }

  ngOnInit() {
    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe(sessionData => {
        this.sessionData = sessionData;
        if (sessionData.user_type !== UserType.MASTER) {
          this.showExportButton = true;
        }
        this.tableColumns = this.getTableColumns();
        this.tableReady = true;

        if (sessionData.popup_tips) {
          if (this.popupShown) {
            return;
          }

          this.popupShown = true;
          this.store.dispatch(
            openDialog({
              dialogData: {
                content: InfoTipsComponent,
                title: 'Tips',
                canClose: true,
                dialogMinWidth: '700px',
                componentData: {
                  type: 'meeting_popup',
                },
              },
            }),
          );
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next(false);
  }

  onColumnClick(item: IMeetingItem) {
    this.router.navigate(['/messages/view/meeting', item.meeting_id]);
  }

  onData = (items: IOpportunity[]) => {
    // this.store.dispatch(setMessagesList({list: items.map(item => item.message_id)}));
  };
}
